import { render, staticRenderFns } from "./cPopup.vue?vue&type=template&id=0f464a80&scoped=true"
import script from "./cPopup.vue?vue&type=script&lang=js"
export * from "./cPopup.vue?vue&type=script&lang=js"
import style0 from "./cPopup.vue?vue&type=style&index=0&id=0f464a80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f464a80",
  null
  
)

export default component.exports